export const gas = {
    send: 100000,
    vote: 100000,
    delegate: 250000,
    un_delegate: 300000,
    re_delegate: 350000,
    claim_reward: 200000,
};
